import { IBrand } from '@/api/brands/queries/get-brand-query'
import { IApi, useClientApi } from '@/setup/api-client'
import { IApiError } from '@/utils/api/api-types'
import { useApiQuery } from '@/utils/api/api-query'
import { useOrganization } from '@clerk/nextjs'
import { UseQueryOptions } from '@tanstack/react-query'

export const BRAND_QUERY_BASE_KEY = ['brands']

type IGetBrandsQueryOptions = Pick<UseQueryOptions<IBrand[], IApiError>, 'refetchInterval' | 'retry'>

export class GetBrandsQuery {
    static getKey(params: { organizationId: string }) {
        return [...BRAND_QUERY_BASE_KEY, 'organization', params.organizationId, 'get-brands-query']
    }

    static async call(api: IApi, params: { organizationId: string }) {
        return api.get<IBrand[]>(`/organization/${params.organizationId}/brands`).then((res) => res.data)
    }
}

export function useGetBrandsQuery(enabled: boolean = true, options?: IGetBrandsQueryOptions) {
    const queryClient = useClientApi()
    const { organization } = useOrganization()

    return useApiQuery({
        queryKey: GetBrandsQuery.getKey({ organizationId: organization?.id ?? '' }),
        queryFn: () => GetBrandsQuery.call(queryClient, { organizationId: organization?.id ?? '' }),
        enabled: !!organization?.id && enabled,
        refetchInterval: options?.refetchInterval,
        retry: options?.retry ?? false,
        // Seeded values (create-empty-brand-mutation prepends the new brand) must
        // not be marked stale on first mount or the sidebar refetches straight
        // into the lagged replica and hides the new brand until focus.
        staleTime: 30 * 1000,
    })
}
